import React, { Component} from 'react';
import {Redirect} from 'react-router-dom'

import API from'../utilities/API'

//import {BrowserRouter as Router,  NavLink, Redirect  } from 'react-router-dom'

class PasswordRequest extends Component {
 
constructor (props) {
    super(props);

    this.inviteReturn = this.inviteReturn.bind(this);
    let emailaddy = '';
    if(!props.data.usr.email){}else{emailaddy=props.data.usr.email}
    this.state = {display:0,
                  e:emailaddy,
                  errE: null,
    }
     
}

handleOnChange = event => {
  event.preventDefault();
  const { name, value } = event.target;
  
  this.setState({
    [name]: value
  });
  
}

handleSubmit = event => {
  event.preventDefault();
    
    let e = this.state.e;
    const Reg = {
      email: e,
    }
    
  if(this.validate()){
    
    //console.log('GO GO GO GO SPEED RACER!', Reg)
  
    API.requestreset(Reg, this.inviteReturn);
  }  
}
inviteReturn(outcome){
  console.log(outcome.data);
  let NextDisplay = 0;
  if (outcome.data){
  switch(outcome.data){
    case 'Email Sent':
      NextDisplay = 1;
      break;
    case 'No Email':
      NextDisplay = 2;
      break;
    default:
       NextDisplay = 3;
      break;
  }}
 
  this.setState({e:'', display:NextDisplay});
}

validate(){
  
  let isValid = true;
  let errorE = null;

  if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.e))){
    errorE="Invalid email format";
    isValid = false; 
  }
  if(this.state.e.length<=0){
    errorE= "Email can not be blank.";
    isValid = false;
  }

  

  this.setState({errE: errorE})
  
  return isValid;
}

render() { 
  let regPage = ()=>(<div></div>);
  switch(this.state.display){
    case 0:
    regPage = ()=> (<div className='mypage fluid-container p-3'>
    <div className='row'>
    
    <div className='col-3' Style="min-width: 200px">
    <h2>Password Reset Request</h2>
    
    <div className='row'>
    <div className='myfldlbl col-12 mx-2'>Email</div>
    <div className='col-12 mx-2'><input className="form-control" type='text' name='e' value={this.state.e} onChange={this.handleOnChange}/></div>
    <div className='myerr col-12 mx-2'>{this.state.errE}</div>
    </div>
  
    <div className='row'>
    <div className='col-12 mx-2'>
    <div className="btn btn-dark mt-2" onClick={this.handleSubmit}>Request Reset</div>
    </div>
    </div>
    
    </div>
    {/* <div className='col-9'>
    {<Privacy/>}
    </div> */}
    </div>  
    
    </div>
    );
    break;
    

    case 1:
     regPage = ()=> (<div className='fluid-container p-3'>
    <h2>Password Reset Email Sent!</h2>
    <p>You should receive an email within the next few minutes that has a link to reset your password.</p> 
    </div>)
      break;
    
    case 2:
      regPage = ()=> (<Redirect to="/register"/>);
       break;
      
    default:
    
      regPage = ()=> (<div className='fluid-container p-3'>
     
     <h2>Something went wrong...</h2>
     <p>Please give us a few moments while we figure out what just happened... and try again later!</p>
     </div>);
       break;
    
     
  }
  
  return (regPage());            
          

  
}
}

export default PasswordRequest;


// WEBPACK FOOTER //
// ./src/components/PasswordRequest.js